module.exports = __webpack_public_path__ + "static/media/cookie.d7d85b70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/cookie.png
// module id = 126
// module chunks = 0